import api from "./Api";

class MotoristaService {
  GetMotorista(payload) {
    return api.get("/v1/motorista/" + payload).then((response) => {
      return response.data;
    });
  }

  PostMotorista(payload) {
    return api.post("/v1/motorista/", payload).then((response) => {
      return response.data;
    });
  }

  PutMotorista(payload) {
    return api.put("/v1/motorista/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteMotorista(payload) {
    return api.delete("/v1/motorista/" + payload).then((response) => {
      return response.data;
    });
  }

  GetMotoristaOData(payload) {
    return api.get("/OData/Motorista" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new MotoristaService();
